module.exports = __webpack_public_path__ + "static/media/pcSecondaryAuthMock.766f2dbc.png";